import { SkedMentionItem } from "./sked-mention-box";

export class LocalStorageCache<T extends SkedMentionItem> {
  private storageKey;
  private maxItems = 10;
  constructor(storageKey: string, maxItems = 10) {
    this.storageKey = storageKey;
    this.maxItems = maxItems;
  }
  getItems(): (T & { _t?: number })[] {
    const raw = localStorage.getItem(this.storageKey);
    if (raw) {
      try {
        const items = JSON.parse(raw) as (T & { _t?: number })[];

        return items;
      } catch (error) {
        console.error("Error parsing localStorage item:", error);
        return [];
      }
    }
    return [];
  }
  addItem(item: T) {
    const items = this.getItems();
    const filtered = items.filter((i) => i.key !== item.key);
    filtered.unshift({ ...item, _t: Date.now() });
    if (filtered.length > this.maxItems) {
      filtered.splice(this.maxItems);
    }
    localStorage.setItem(this.storageKey, JSON.stringify(filtered));
  }
}
